import { render, staticRenderFns } from "./Endereco-2.vue?vue&type=template&id=131a0090&scoped=true&"
import script from "./Endereco-2.vue?vue&type=script&lang=js&"
export * from "./Endereco-2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "131a0090",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/williamsalmeida/www/hubcompras/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('131a0090')) {
      api.createRecord('131a0090', component.options)
    } else {
      api.reload('131a0090', component.options)
    }
    module.hot.accept("./Endereco-2.vue?vue&type=template&id=131a0090&scoped=true&", function () {
      api.rerender('131a0090', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/recursos/Endereco-2.vue"
export default component.exports